
export default function createUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

//export default function createUUID() { // RFC 4122-ish
//    return Array.from(Array(32))
//        .map((e, i) => {
//            let someRandomValue = i === 12 ? 4 : (+new Date() + Math.random() * 16) % 16 | 0;
//            return `${~[8, 12, 16, 20].indexOf(i) ? "-" : ""}${
//                (i === 16 ? someRandomValue & 0x3 | 0x8 : someRandomValue).toString(16)}`;
//        }).join("");
//}